import "../../styles/reset.less";
import "../../styles/global.less";
import "./pay-solution.less";
import $ from "jquery";

// var scrollTop = 0;

$(document).ready(function () {
  $("#topHeader").css(
    "background-color",
    "rgba(1, 84, 155, 1)"
  );
  // $(window).scroll(function () {
  //   scrollTop = $(document).scrollTop();

  //   var difference = scrollTop - 500;
  //   var topOpacity = 0;

  //   if (difference > 70) {
  //     topOpacity = 0;
  //   }

  //   if (difference > 0 && difference < 70) {
  //     topOpacity = difference / 70;
  //   }

  //   if (difference >= 70) {
  //     topOpacity = 1;
  //   }

  //   $("#topHeader").css(
  //     "background-color",
  //     "rgba(1, 84, 155," + topOpacity + ")"
  //   );
  // });

});

